import React from 'react';
import PropTypes from 'prop-types';
import { Section, Container, Column, Row, H3, Link } from 'components/atoms';
import './Cities.scss';
export function Cities({ title, cities }) {
	return (
		<Section>
			<Container>
				<Row>
					<Column>
						<div className="near-by-cities">
							<H3
								weight="extraBold"
								size="medium"
							>
								{title}
							</H3>
							<div className="cities">
								{cities.map(({ slug, name }) => (
									<Link
										key={slug}
										href={slug}
										quaternary
									>
										{name}
									</Link>
								))}
							</div>
						</div>
					</Column>
				</Row>
			</Container>
		</Section>
	);
}
Cities.propTypes = {
	title: PropTypes.string,
	cities: PropTypes.arrayOf(PropTypes.object),
};
export default Cities;
